module.exports = __webpack_public_path__ + "d4cde2fda0bbae265d68e0baeeae88be.png";